<template>
    <div class="boats-grid-item wow fadeInUp" data-wow-duration="2s" tabindex="0">
        <div class="boats-grid-item-top">
            <img :src="boat.image" alt="" class="pic">
            <img src="/img/pic-cover.png" alt="" class="pic-cover">

            <div class="price-info">
                <div class="price">{{ current_price | toFixed | toUSD }}</div>

                <div class="buttons-type-multiselect two-btns">
                    <div class="item" v-for="(hour, index) in time" :key="index">
                        <input
                            type="radio"
                            class="rad yacht__hours"
                            :name="`hours-${boat.id}`"
                            :id="`${hoursFormat(hour.hours)}-${boat.id}`"
                            :value="hour.hours"
                            v-model="hours"
                            @change="setPrice(hour)"
                        >
                        <label :for="`${hoursFormat(hour.hours)}-${boat.id}`">
                            <div class="ttl">{{ hoursFormat(hour.hours) }}</div>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="boats-grid-item-content">
            <h5>{{ boat.name }}</h5>

            <ul class="info-list">
                <li v-for="feature in boat.includes">
                    <img :src="feature.icon" alt="icon" class="icon">
                    <p>{{ feature.content }}</p>
                </li>
            </ul>
            <a :href="boatUrl" class="btn btn--primary-outline">View Details</a>
        </div>
        <div class="text-deco wow" :class="showBoatName()" data-wow-delay="1s">
            <span>{{ boat.short_name }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "BoatItem",
    props: {
        boat: {
            type: Object,
            required: true
        },
        boatIndex: {
            type: Number | String,
            required: true
        }
    },
    data() {
        return {
            time: [
                {
                    hours: 4,
                    price: 'price_4h'
                },
                {
                    hours: 6,
                    price: 'price_6h'
                },
                {
                    hours: 8,
                    price: 'price_8h'
                },
            ],
            hours: 4,
            current_price: this.boat.price_4h
        }
    },
    computed: {
        boatUrl() {
            return `${this.boat.url}?hours=${this.hours}`
        }
    },
    methods: {
        hoursFormat(hour) {
            return `${hour}h`
        },
        showBoatName() {
           const fadeDirection = this.boatIndex % 2 === 0 ?
               'fadeInRight' :
               'fadeInLeft';

           return `text-deco-${this.boatIndex} ${fadeDirection}`;
        },
        setPrice(hour) {
            this.current_price = this.boat[hour.price]
        },
    }
}
</script>

<style scoped>
    .yacht__hours {
        cursor: pointer;
    }
</style>
